@if (!closeCookiesPolicyWarning) {
  <div class="policy">
    <p class="policy__warning">{{ 'policy.warning' | transloco }}</p>
    <div class="policy__links">
      <a routerLink="/cookies" target="_blank">
        <button class="btn btn-secondary btn-sm policy__links__learn-more" name="policy_learn_more">
          {{ 'policy.learn_more' | transloco }}
        </button>
      </a>
      <div class="policy__links__agree" (click)="closePolicy()">
        {{ 'policy.agree' | transloco }}
        <mat-icon svgIcon="md-close" class="icon icon-16 policy__links__close icon-white cursor-pointer" matSuffix mat-icon-button />
      </div>
    </div>
  </div>
}
@if (data$ | async; as vm) {
  @if (vm.showFooter) {
    <footer class="footer bg-grey-100 dark:bg-grey-dark-200 relative" [class.footer--login]="router.url === '/login'">
      <div class="container flex justify-center">
        <div class="flex flex-wrap">
          <div class="col text-center">
            <mat-icon svgIcon="logo-blue" class="icon icon-logo-small" />
            <div
              class="footer__nav border-grey-300 text-grey-1000 dark:border-grey-dark-250 dark:text-grey-dark-1000 mt-4 flex gap-4 border-t pt-4"
            >
              <a
                href="http://www.engie.com"
                target="_blank"
                rel="noopener"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
                >{{ 'footer.engie_dot_com' | transloco }}</a
              >
              <a
                href="http://www.engie.com/sites-du-groupe/"
                target="_blank"
                rel="noopener"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
              >
                {{ 'footer.engie_websites' | transloco }}
              </a>
              <a
                routerLink="/terms-of-use"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
                >{{ 'terms_of_use.title_0' | transloco }}</a
              >
              <a
                routerLink="/cookies"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
                >{{ 'footer.cookies' | transloco }}</a
              >
              <a
                routerLink="/privacy-policy"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
                >{{ 'footer.privacy_policy' | transloco }}</a
              >
              @if (vm.isLoggedIn && vm.isAdmin && vm.isAllowed) {
                <span>
                  <a
                    routerLink="/mission-roadmap"
                    class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                    [class.footer__nav__item--login]="router.url === '/login'"
                    >Mission Roadmap</a
                  ></span
                >
              }
              @if (vm.isLoggedIn) {
                <span>
                  <a
                    routerLink="/help"
                    class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                    [class.footer__nav__item--login]="router.url === '/login'"
                    >{{ 'footer.help' | transloco }}</a
                  >
                </span>
              }
              <a
                href="mailto:wattson@engie.com"
                class="footer__nav__item text-grey-1000 dark:text-grey-dark-1000 hover:dark:text-blue-dark-700 hover:text-blue-700"
                [class.footer__nav__item--login]="router.url === '/login'"
                >{{ 'footer.contact_us' | transloco }}</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="from-engie-blue to-engie-green absolute bottom-0 left-0 h-[3px] w-full bg-gradient-to-r"></div>
    </footer>
  }
}
